import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ComponentService } from '../../services/component/component.service';
import { ComponentInputBase } from '../../models/ComponentInputBase.model';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ComponentLibraryService } from '../../services/component-library/component-library.service';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-text',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './text.component.html',
  styleUrl: './text.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class TextComponent extends ComponentInputBase {
  processedContent: SafeHtml | null = null;

  constructor(
    componentService: ComponentService,
    private componentLibrary: ComponentLibraryService
  ) {
    super(componentService);
    this.dynamicInput = {
      content: {
        type: 'HTMLText',
        value: '',
      },
    };
  }

  ngOnInit() {
    this.updateContent();
  }

  ngOnChanges() {
    this.updateContent();
  }

  private updateContent() {
    const content = this.getInput('content');

    if (!content) {
      this.processedContent = null;
      return;
    }

    // Process the content through ComponentLibraryService
    this.processedContent = this.componentLibrary.processShortcodes(content);
  }
}
